import { FileUploader } from '@tfecom-thermofisher/react-komodo-design';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Message, Modal } from 'src/core/components';

import withModal from '../withModal';
import messages from './messages';

const UploadFileComponent = ({
  isOpen,
  handleClose,
  handleOpen,
  title,
  description,
  files,
  submitDisabled,
  handleSubmit,
  uploadFile,
  resetData,
}) => {
  const handleCloseModal = () => {
    if (resetData) {
      resetData();
    }
    handleClose();
  };

  const ModalContent = (
    <FileUploader
      files={files}
      fileBrowseTitle={<Message message={messages.browse} />}
      dragDropTitle={<Message message={messages.dragAndDrop} />}
      uploadFile={uploadFile}
      deleteFile={resetData}
    />
  );

  return (
    <>
      <Button
        data-testid="upload-file-button"
        type="tertiary"
        label={messages.uploadFile}
        onClick={handleOpen}
      />
      <Modal
        {...{
          id: 'UploadFilesModal',
          isOpen,
          title,
          description,
          handleClose: handleCloseModal,
          handleSubmit,
          submitBtnLabel: messages.upload,
          submitDisabled,
          content: ModalContent,
        }}
      />
    </>
  );
};

UploadFileComponent.propTypes = {
  // withModal props
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  handleOpen: PropTypes.func.isRequired,

  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  files: PropTypes.array,
  submitDisabled: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  uploadFile: PropTypes.func.isRequired,
  resetData: PropTypes.func,
};

export default withModal(UploadFileComponent);
